export default __webpack_public_path__ + "3f7a08455620fb61df9f2e26c5457308.png";